import BusinessEmailsTabComponent from './BusinessEmailsTab';

export const BusinessEmailsTab = BusinessEmailsTabComponent;
